/** Conversation history is persisted locally on the client (decision: lokal). */

export interface Conversation {
  id: string
  title: string
  /** Token count shown as "9 T." in the Verlauf popover. */
  tokens: number
  updatedAt: number
  turns: { role: 'user' | 'assistant'; content: string }[]
}

export interface HistoryStore {
  list(): Conversation[]
  save(conversation: Conversation): void
  remove(id: string): void
  clear(): void
}

/** localStorage-backed history store (works in the Office WebView). */
export function createLocalHistoryStore(storageKey = 'saip.history'): HistoryStore {
  const read = (): Conversation[] => {
    try {
      return JSON.parse(localStorage.getItem(storageKey) ?? '[]') as Conversation[]
    } catch {
      return []
    }
  }
  const write = (list: Conversation[]) => localStorage.setItem(storageKey, JSON.stringify(list))

  return {
    list: () => read().sort((a, b) => b.updatedAt - a.updatedAt),
    save: (conversation) => {
      const list = read().filter((c) => c.id !== conversation.id)
      list.push(conversation)
      write(list)
    },
    remove: (id) => write(read().filter((c) => c.id !== id)),
    clear: () => write([]),
  }
}

/** Sample entries so the Verlauf popover looks populated before any real chats. */
export const SAMPLE_HISTORY: Conversation[] = [
  { id: 'h1', title: 'verbessere den text', tokens: 9, updatedAt: 9, turns: [] },
  { id: 'h2', title: 'Muss ich als deutsches Unternehmen…', tokens: 9, updatedAt: 8, turns: [] },
  { id: 'h3', title: 'schreibe Mail per Du: Sehr gee…', tokens: 11, updatedAt: 7, turns: [] },
  { id: 'h4', title: 'Schreib die Tabelle im Angebo…', tokens: 11, updatedAt: 6, turns: [] },
  { id: 'h5', title: 'Schreibe die Rechnung auf he…', tokens: 53, updatedAt: 5, turns: [] },
  { id: 'h6', title: 'Ändere die Anschrift des Ang…', tokens: 53, updatedAt: 4, turns: [] },
]
